if (!customElements.get("mini-checkout")) {
  customElements.define(
    "mini-checkout",
    class MiniCheckout extends HTMLElement {
      constructor() {
        super();

        this.updateHeaderOffset = this.updateHeaderOffset.bind(this);
        this.updateScrollVisibility = this.updateScrollVisibility.bind(this);
        this.updateHeaderOffset();
        this.updateScrollVisibility();
        window.addEventListener("resize", this.updateHeaderOffset, { passive: true });
        window.addEventListener("scroll", this.updateHeaderOffset, { passive: true });
        window.addEventListener("scroll", this.updateScrollVisibility, { passive: true });
        window.addEventListener("resize", this.updateScrollVisibility, { passive: true });
        this.expandButton = this.querySelector(".expand-button");
        if (!this.expandButton) return;

        this.boundToggleExpand = this.toggleExpand.bind(this);
        this.expandButton.addEventListener("click", this.boundToggleExpand);

        // Listen for variant and quantity change events
        this.boundOnChange = this.onChange.bind(this);
        this.addEventListener("change", this.boundOnChange);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.updateHeaderOffset);
        window.removeEventListener("scroll", this.updateScrollVisibility);
        window.removeEventListener("resize", this.updateScrollVisibility);
        window.removeEventListener("scroll", this.updateHeaderOffset);
        if (this.boundToggleExpand)
          this.expandButton.removeEventListener(
            "click",
            this.boundToggleExpand,
          );
        if (this.boundOnChange)
          this.removeEventListener("change", this.boundOnChange);
      }

      updateScrollVisibility() {
        const sku = document.getElementById("Sku-" + this.dataset.section);
        const variantPicker = document.getElementById("Variant-Selects-" + this.dataset.section)
          || document.querySelector(".product-info .product-variant-selects:not(.mini-variant-selects)");
        const anchor = sku || variantPicker;
        if (!anchor) {
          this.classList.remove("ha-scroll-revealed");
          return;
        }
        const topLimit = parseFloat(this.style.getPropertyValue("--ha-mini-header-bottom")) || 0;
        const pastOriginal = anchor.getBoundingClientRect().bottom < topLimit;
        this.classList.toggle("ha-scroll-revealed", pastOriginal);
      }

      updateHeaderOffset() {
        const header = document.querySelector("header.header, .section-header header, header");
        if (!header) return;
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        this.style.setProperty("--ha-mini-header-bottom", `${bottom}px`);
      }

      /**
       * Toggle expand/collapse state
       */
      toggleExpand() {
        this.classList.toggle("has-expand");
        this.expandButton.setAttribute(
          "aria-expanded",
          this.classList.contains("has-expand"),
        );
      }

      syncComboVariant(select) {
        const option = select.selectedOptions[0];
        if (!option || option.disabled) return;
        let values;
        try { values = JSON.parse(option.dataset.options || "[]"); } catch (_) { return; }
        const sectionId = this.dataset.section;
        values.forEach((value, index) => {
          const mainId = "Option-" + sectionId + "-" + index;
          const target = document.getElementById(mainId);
          if (target && target.tagName === "SELECT") {
            target.value = value;
            target.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            const radios = Array.from(document.querySelectorAll('input[type="radio"]')).filter(input => input.name && input.name.includes("options") && input.value === value);
            const radio = radios.find(input => input.closest(".product-info") && !input.closest("mini-checkout")) || radios[0];
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        });
        const price = this.querySelector(".ha-mini-price");
        const sku = this.querySelector(".ha-mini-sku");
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (sku) sku.textContent = "SKU: " + (option.dataset.sku || "");
      }

      /**
       * Sync mini-checkout input changes to the main product form
       * @param event
       */
      onChange(event) {
        const inputElement = event.target;
        if (!inputElement) return;

        if (inputElement.matches(".ha-combo-select")) {
          this.syncComboVariant(inputElement);
          return;
        }
        const targetId = inputElement.dataset.target;
        if (!targetId) return;

        const targetInputElement = document.getElementById(targetId);
        if (!targetInputElement) return;

        if (
          targetInputElement.tagName === "INPUT" &&
          targetInputElement.type === "radio"
        ) {
          // Handle radio inputs
          targetInputElement.checked = true;
        } else {
          // Handle other inputs (select, text, etc.)
          targetInputElement.value = inputElement.value;
        }

        // Dispatch change event to sync with the main form
        targetInputElement.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
      }
    },
  );
}
